export default __webpack_public_path__ + "static/about_graphic-ac4fca6d4bbc04c0e0d1dbbd90f44914.png";